import { render, staticRenderFns } from "./choose-language.vue?vue&type=template&id=f756f41c&scoped=true&"
import script from "./choose-language.vue?vue&type=script&lang=js&"
export * from "./choose-language.vue?vue&type=script&lang=js&"
import style0 from "./choose-language.vue?vue&type=style&index=0&id=f756f41c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f756f41c",
  null
  
)

export default component.exports